module.exports = __webpack_public_path__ + "static/media/profilePic.77b66bf8.jpg";